import Link from 'next/link'

type ButtonLinkProps = {
    href: string
    children: React.ReactNode
    variant?: 'solid' | 'light' | 'ghost'
    className?: string
}

export default function ButtonLink({ href, children, variant = 'solid', className = '' }: ButtonLinkProps) {
    const styles =
        variant === 'light'
            ? 'bg-white/12 text-white shadow-md backdrop-blur-md hover:bg-white/18'
            : variant === 'ghost'
              ? 'bg-transparent text-brand hover:bg-brand/6'
              : 'bg-brand text-white shadow-md hover:bg-brand-accent'

    return (
        <Link
            href={href}
            className={[
                'inline-flex items-center rounded-full px-6 py-3 text-sm font-semibold',
                'transition-[background-color,color,box-shadow,opacity] duration-400',
                styles,
                className
            ].join(' ')}>
            {children}
        </Link>
    )
}
